import React from 'react';

const Industries = () => {
  return (
    <section className="positionCards-sec undefined" id="industries">
      <div className="undefined px-6 lg:px-8 pt-14 md:pt-24 lg:pt-[10.5rem] max-w-7xl mx-auto">
        <div className="2xl:max-w-4xl lg:max-w-3xl lg:pb-[88px] pb-12">
          <div className="lg:overflow-hidden">
            <h2 className="font-bold sentence-first-letter text-4xl xl:text-5xl 2xl:text-6xl tracking-[-2px] lg:-translate-y-[7px] xl:!leading-[55px] 2xl:!leading-[65px]">
              <span>industries we serve</span>
            </h2>
          </div>
          <p className="lg:pt-[2.375rem] pt-6 text-base md:text-md lg:text-lg xl:text-xl 2xl:text-2xl">
            We build advanced mobile apps for industries that create an impact,
            streamline key processes, and drive measurable results.
          </p>
        </div>
        <div className="mx-auto max-w-7xl">
          <div className="grid max-w-2xl grid-cols-1 gap-5 lg:gap-10 lg:mx-0 lg:max-w-none sm:grid-cols-2 lg:grid-cols-3">
            <article className="group xl:p-7 p-6 lg:rounded-[30px] rounded-2xl border border-[#CCCCCC] hover:border-[#2ED06E] hover:shadow-[0_0_0_3px_#2ED06E] duration-500 undefined ">
              <a className="flex flex-col h-full">
                <h3 className=" font-bold leading-7 text-2xl xl:text-3xl 2xl:text-4xl tracking-[0px]">
                  Automotive
                </h3>
                <div className="flex flex-col justify-between h-full">
                  <div className="mb-[50px] mt-5 2xl:h-[128px]">
                    <p className="undefined text-base md:text-md lg:text-lg xl:text-xl 2xl:text-2xl">
                      Improve your vehicle management and enhance customer
                      satisfaction with custom solutions.
                    </p>
                  </div>
                  <div />
                </div>
              </a>
            </article>
            <article className="group xl:p-7 p-6 lg:rounded-[30px] rounded-2xl border border-[#CCCCCC] hover:border-[#2ED06E] hover:shadow-[0_0_0_3px_#2ED06E] duration-500 undefined ">
              <a className="flex flex-col h-full">
                <h3 className=" font-bold leading-7 text-2xl xl:text-3xl 2xl:text-4xl tracking-[0px]">
                  Finance
                </h3>
                <div className="flex flex-col justify-between h-full">
                  <div className="mb-[50px] mt-5 2xl:h-[128px]">
                    <p className="undefined text-base md:text-md lg:text-lg xl:text-xl 2xl:text-2xl">
                      Get scalable solutions that improve the efficiency and
                      security of your financial services.
                    </p>
                  </div>
                  <div />
                </div>
              </a>
            </article>
            <article className="group xl:p-7 p-6 lg:rounded-[30px] rounded-2xl border border-[#CCCCCC] hover:border-[#2ED06E] hover:shadow-[0_0_0_3px_#2ED06E] duration-500 undefined ">
              <a className="flex flex-col h-full">
                <h3 className=" font-bold leading-7 text-2xl xl:text-3xl 2xl:text-4xl tracking-[0px]">
                  Real Estate
                </h3>
                <div className="flex flex-col justify-between h-full">
                  <div className="mb-[50px] mt-5 2xl:h-[128px]">
                    <p className="undefined text-base md:text-md lg:text-lg xl:text-xl 2xl:text-2xl">
                      Our real estate solutions streamline operations,
                      simplifying property management and sales.
                    </p>
                  </div>
                  <div />
                </div>
              </a>
            </article>
            <article className="group xl:p-7 p-6 lg:rounded-[30px] rounded-2xl border border-[#CCCCCC] hover:border-[#2ED06E] hover:shadow-[0_0_0_3px_#2ED06E] duration-500 undefined ">
              <a className="flex flex-col h-full">
                <h3 className=" font-bold leading-7 text-2xl xl:text-3xl 2xl:text-4xl tracking-[0px]">
                  Hospitality
                </h3>
                <div className="flex flex-col justify-between h-full">
                  <div className="mb-[50px] mt-5 2xl:h-[128px]">
                    <p className="undefined text-base md:text-md lg:text-lg xl:text-xl 2xl:text-2xl">
                      Get user-friendly solutions that enhance guest experiences
                      and boost customer satisfaction.
                    </p>
                  </div>
                  <div />
                </div>
              </a>
            </article>
            <article className="group xl:p-7 p-6 lg:rounded-[30px] rounded-2xl border border-[#CCCCCC] hover:border-[#2ED06E] hover:shadow-[0_0_0_3px_#2ED06E] duration-500 undefined ">
              <a className="flex flex-col h-full">
                <h3 className=" font-bold leading-7 text-2xl xl:text-3xl 2xl:text-4xl tracking-[0px]">
                  Education
                </h3>
                <div className="flex flex-col justify-between h-full">
                  <div className="mb-[50px] mt-5 2xl:h-[128px]">
                    <p className="undefined text-base md:text-md lg:text-lg xl:text-xl 2xl:text-2xl">
                      Revolutionize ed-tech with solutions that boost student
                      engagement and simplify learning.
                    </p>
                  </div>
                  <div />
                </div>
              </a>
            </article>
            <article className="group xl:p-7 p-6 lg:rounded-[30px] rounded-2xl border border-[#CCCCCC] hover:border-[#2ED06E] hover:shadow-[0_0_0_3px_#2ED06E] duration-500 undefined ">
              <a className="flex flex-col h-full">
                <h3 className=" font-bold leading-7 text-2xl xl:text-3xl 2xl:text-4xl tracking-[0px]">
                  Healthcare
                </h3>
                <div className="flex flex-col justify-between h-full">
                  <div className="mb-[50px] mt-5 2xl:h-[128px]">
                    <p className="undefined text-base md:text-md lg:text-lg xl:text-xl 2xl:text-2xl">
                      Our solutions enhance healthcare by streamlining processes
                      and improving patient care.
                    </p>
                  </div>
                  <div />
                </div>
              </a>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Industries;
